module.exports = __webpack_public_path__ + "static/37-34371a5557acec6318cf6c8e190c15a3.jpg";